import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeIn12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFadeIn12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#FadeIn12)">
                    <path
                        fill="currentColor"
                        d="M6.617.683a5.35 5.35 0 0 1 4.757 5.315l-.008.275A5.35 5.35 0 0 1 6.63 11.31a.5.5 0 0 1-.118.019.45.45 0 0 1-.45-.45V1.121a.45.45 0 0 1 .555-.438m-1.919.25a.45.45 0 0 1 .45.45v9.233a.45.45 0 0 1-.9 0V1.383a.45.45 0 0 1 .45-.45m2.264 9.411a4.447 4.447 0 0 0 0-8.693zM2.889 1.895a.45.45 0 0 1 .45.45v7.312a.451.451 0 0 1-.9 0V2.345a.45.45 0 0 1 .45-.45M1.077 3.527a.45.45 0 0 1 .45.45v4.045a.451.451 0 0 1-.9 0V3.977a.45.45 0 0 1 .45-.45"
                    />
                </g>
                <defs>
                    <clipPath id="FadeIn12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconFadeIn12);
